// extracted by mini-css-extract-plugin
export default {"menu":"MobileMenu_menu__TnoBI","icons":"MobileMenu_icons__R1y5u","last":"MobileMenu_last__iFIVB","active":"MobileMenu_active__OReuq"};